import React, { useState } from 'react';
import { Star } from 'lucide-react';

export default function StarRating({ value = 0, onChange, maxStars = 5, size = 'md', readonly = false }) {
    const [hover, setHover] = useState(0);
    const sizes = { sm: 'w-5 h-5', md: 'w-7 h-7', lg: 'w-9 h-9' };
    const cls = sizes[size] || sizes.md;

    return (
        <div className="flex gap-1" role="radiogroup" aria-label="Rating">
            {Array.from({ length: maxStars }).map((_, i) => {
                const starVal = i + 1;
                const filled = starVal <= (hover || value);
                return (
                    <button key={i} type="button" disabled={readonly}
                        onClick={() => onChange?.(starVal)}
                        onMouseEnter={() => !readonly && setHover(starVal)}
                        onMouseLeave={() => !readonly && setHover(0)}
                        onKeyDown={e => {
                            if (e.key === 'ArrowRight' && starVal < maxStars) onChange?.(starVal + 1);
                            if (e.key === 'ArrowLeft' && starVal > 1) onChange?.(starVal - 1);
                        }}
                        aria-label={`${starVal} star${starVal > 1 ? 's' : ''}`}
                        className={`transition-transform ${!readonly ? 'hover:scale-110 cursor-pointer' : 'cursor-default'}`}>
                        <Star className={`${cls} transition-colors ${filled ? 'text-amber-400 fill-amber-400' : 'text-stone-300'}`} />
                    </button>
                );
            })}
        </div>
    );
}
